import React from "react";
import PropTypes from 'prop-types';
import {
  PopHeader,
  InfoWrapper,
  QuestionWrap,
  AnswerWrap,
  QASection,
  PrimaryButtonOkay,
  DisplayFlexOkay,
  QASectionWrapper,
  InfoContentWrapper,
  IconWrap,
} from "./styles";
import { Icon } from "antd";

class ViewAdditionalInfo extends React.Component {
  QAArr = [
    {
      question:
        "How is the electronic delivery option applied and how long does it last?",
      answer: `Your indicated preference applies to all documents that can be
                delivered electronically for all accounts where you are authorized
                to access accountinformation. It will be effective until you or
                Vanguard Charitable revoke it.`
    },
    {
      question: "How will I know when documents are available online?",
      answer: `You may receive an email when a new document is made available online.`
    },
    {
      question: "When and how will I see documents online?",
      answer: `Transaction confirmations are generally available online two to three business days after the activity is complete.
                Account statements are available online approximately five days after the end of each period.
                To view a document online, click My account at vanguardcharitable.org. Enter your user ID and password, click Log in, and you will be directed to the Account summary page. Click the Reports tab and you will be brought to the Statements and confirmations page.`
    },
    {
      question: "How are documents retained?",
      answer: `Download or print account documents under Reports in your online account or contact us to request copies.`
    },
    {
      question: "Do I need special software for electronic delivery?",
      answer: `You must have Adobe Acrobat Reader to view account reports online. You can download this software free
                from Adobe's website at www.adobe.com.`
    },
    {
      question:
        "How do I change my contact information or my delivery preferences?",
      answer: `Log in to your philanthropic account.
                Navigate to Profile under Account in the top gray bar.
                Click Edit by the respective subject to change contact information or delivery preferences.`
    }
  ];
  render() {
    return (
      <InfoWrapper>
        <InfoContentWrapper>
          <IconWrap>
            <Icon type="close" onClick={this.props.handleOkay} />
          </IconWrap>
          <PopHeader>
            Funding Instructions
          </PopHeader>
          <QASection>
            {this.QAArr.map(data => {
              return (
                <QASectionWrapper>
                  <QuestionWrap>{data.question}</QuestionWrap>
                  <AnswerWrap>{data.answer}</AnswerWrap>
                </QASectionWrapper>
              );
            })}
            <QASectionWrapper>
              <QuestionWrap>
                What other e-delivery issues should I consider?
              </QuestionWrap>
              <AnswerWrap>
                Sometimes errors occur in email transmission. If you do not
                receive an expected email notification, log in to your account
                to view the information or contact us.
              </AnswerWrap>
            </QASectionWrapper>
          </QASection>
          <DisplayFlexOkay>
            <PrimaryButtonOkay onClick={this.props.handleOkay}>
              OKAY
            </PrimaryButtonOkay>
            </DisplayFlexOkay>
        </InfoContentWrapper>
      </InfoWrapper>
    );
  }
}

ViewAdditionalInfo.propTypes = {
  handleOkay: PropTypes.func
}

export default ViewAdditionalInfo;
